export function assert(value, message) {
    if (value === false || value === null || typeof value === 'undefined') {
        throw new Error(message || 'Assertion failed');
    }
}
